const capitalize = (s: string) => s.length < 1 ? s : s.charAt(0).toUpperCase() + s.slice(1);

export default capitalize;
